import * as React from "react";
import { AccountType, IAccount } from "dto/access-management/account-dto";
import { useAccountStore, useAuthStore } from "store";
import { ITreeSelectDataSource } from "store/account-store";

interface ISelectableDataSource {
    viewableTypes?: AccountType[];
    selectableTypes: AccountType[];
    defaultAccountHierarchy?: IAccount;
    defaultSelectedAccount?: number | string | null;
    onAccountChange?: (account: IAccount, context?: { isInitial?: boolean }) => Promise<void>;
}
export const useAccountTreeSelector = (options: ISelectableDataSource, otherDeps: any[] = []) => {
    const { onAccountChange } = options;
    const { currentUser } = useAuthStore();
    const accountStore = useAccountStore();
    const dataSource = React.useMemo<ITreeSelectDataSource>(
        () => accountStore.getSelectableTreeDataSource(options.viewableTypes || Object.values(AccountType), options.selectableTypes, options.defaultAccountHierarchy),
        [currentUser, accountStore.accountHierarchy, ...otherDeps],
    );
    const [selectedAccount, setSelectedAccount] = React.useState<IAccount>(() => {
        if (!options.defaultSelectedAccount) {
            return undefined;
        }
        if (typeof options.defaultSelectedAccount === 'string') {
            return accountStore.getAccountByUuid(options.defaultSelectedAccount);
        }
        return accountStore.getAccountById(options.defaultSelectedAccount);
    });

    React.useEffect(() => {
        onAccountChange && onAccountChange(selectedAccount, { isInitial: true });
    }, []);

    return {
        dataSource,
        selectedAccount,
        onChange: async (accountId: number) => {
            const account = accountStore.getAccountById(accountId);
            setSelectedAccount(account);
            onAccountChange && await onAccountChange(account, { isInitial: false });
        }
    };
}
